import React from 'react'
import './uiuxPage.scss';
import {Link} from 'react-router-dom';
import {} from '../../components/UIUX/uiux';
import LvlLife from '../../assets/images/lvl/LvlLife.png';
import Makkiah from '../../assets/images/makkiah/Makkiah.png';
import ShoeStore from '../../assets/images/shoeStore/ShoeStore.png';


const designs = [
  {
    name: 'Lvl Life',
    to: '/uiux/lvllife',
    img: {
      url:  `${LvlLife}`,
      alt: "Lvl Life designs"
    }, 
    desc: "Lvl Life is a simple productivity and fitness web app designed to help users track their workouts, habits, and daily goals in a clear, minimalist interface.",
    caseStudy: "Includes Case Study"
  }, 
  {
    name: 'Makkiah.com',
    to: '/uiux/makkiah',
    img: {
      url:  `${Makkiah}`,
      alt: "Makkiah.com designs"
    }, 
    desc: "Makkiah.com is my personal website that acts as a hub for anything noteworthy pertaining to me on the internet."
  }, 
  {
    name: 'Omni-Shoe',
    to: '/uiux/shoestore',
    img: {
      url:  `${ShoeStore}`,
      alt: "Shoe Store designs"
    }, 
    desc: "Omni-Shoe is an e-commerce store that I designed for a client that was not able to maintain their shoe reselling store over the long run."
  }, 
]

const UiuxPage = () => {
  return (
    <div className='uiux-p-wrapper'>
      <h1 className='uiux-p-header'>UI/UX</h1>
      <div className='uiux-p-container'>
        {
          designs.map((design, key) => {
            return (
              <Link to={design.to} className="uiux-p-card" key={design.name}>
                <img src={design.img.url} alt={design.img.alt} className='uiux-p-card-img'/>
                <div className='uiux-p-card-div'>
                  <h2 className='uiux-p-card-title'>{design.name}</h2>
                  <p className='uiux-p-card-text'>{design.desc}</p>
                  {
                    design.caseStudy ? <p className='uiux-p-card-text' style={{fontWeight: "bold"}}>{design.caseStudy}</p> : null
                  }
                  <h5 className='uiux-p-card-btn'>More Info</h5>
                </div>
              </Link>
            )
          })
        }
      </div>
    </div>
  )
}

export default UiuxPage;